export const getCodeLabel = (value: unknown): string => {
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }

  if (value && typeof value === 'object' && 'code' in value) {
    const code = (value as { code?: unknown }).code;
    return typeof code === 'string' || typeof code === 'number' ? String(code) : '';
  }

  return '';
};
